import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {StartWeek, airOrderSort} from "@COMPONENTS/common/goodsUtil";
import * as style from "@COMPONENTS/style/productlist/productlistM";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import AirlineIcon from "@FRAMEWORK/ui/mobile/icon/AirlineIcon";
import {GoodsByMenu} from "@QUERIES/prdt/goods/useGoodsByMenu";
import dayjs from "dayjs";
import React, {useEffect, useRef, useState} from "react";

interface Props {
	product: GoodsByMenu;
}

const LocalInfoComponent = ({product}: Props) => {
	// 여행 포인트 정보
	const infoWrapRef = useRef(null);
	const infoContentRef = useRef(null);

	const [showText, setShowText] = useState(false);
	const [shouldShowToggleButton, setShouldShowToggleButton] = useState(false);
	const toggleText = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.stopPropagation();
		setShowText(!showText);
		setShouldShowToggleButton(false);
	};

	useEffect(() => {
		// 여행 포인트 정보 상세 보기 핸들링
		const textHeight = infoContentRef.current?.clientHeight;
		const textWrapHeight = infoWrapRef.current?.clientHeight;

		if (textHeight > textWrapHeight) {
			setShouldShowToggleButton(true);
		} else {
			setShouldShowToggleButton(false);
		}
	}, []);

	const goodsFeatureString = product.goodsFeaturesList
		?.split("|")
		.map(v => v.split(",")[0])
		.join(", ")
		.toString();

	// 출발요일
	const formatDateList = product.startFixOpenDtList?.split(",").map(date => dayjs(date).format("MM.DD"));

	// 이용교통
	const companyList = airOrderSort(product);
	const trArray = companyList.slice(0, 2);
	const otherCdCnt = companyList.length - 2;

	return (
		<>
			{/* 상품명 */}
			<style.ProductTitle>{product.goodsNm}</style.ProductTitle>
			{/* 상품 주요 포인트 정보 */}
			{product.goodsTpointContents && (
				<style.InfoGroup direction="column">
					<style.InfoGroupContent show={showText} ref={infoWrapRef}>
						<em>{goodsFeatureString && <i>{goodsFeatureString}</i>}</em>
						<div ref={infoContentRef}>
							<div
								dangerouslySetInnerHTML={{
									__html: product.goodsTpointContents.replace(/\n/g, "<br>"),
								}}
							></div>
						</div>
						{shouldShowToggleButton && (
							<style.BenefitButtonWrap>
								<style.BenefitButton type="button" onClick={toggleText}>
									<span>더보기</span>
								</style.BenefitButton>
							</style.BenefitButtonWrap>
						)}
					</style.InfoGroupContent>
				</style.InfoGroup>
			)}
			<style.Summary>
				{product.startFixOpenDtList && (
					<dl>
						<dt>출발확정</dt>
						<style.SummaryDeparture>
							<i>{formatDateList.slice(0, 10).join(" / ")}</i>
						</style.SummaryDeparture>
					</dl>
				)}
				<dl>
					<dt>출발기간</dt>
					<dd>{`${dayjs(product.minStartDt).format("YYYY.MM.DD")} ~ ${dayjs(product.maxStartDt).format(
						"YYYY.MM.DD",
					)}`}</dd>
				</dl>
				<dl>
					<dt>출발요일</dt>
					<dd>{StartWeek(product)}</dd>
				</dl>
				{product.airCd && (
					<dl>
						<dt>이용교통</dt>
						<dd>
							<style.Transportation>
								{trArray.map((trString, index) => {
									const trInfoArray = trString.split(",");
									return (
										<AirlineIcon
											key={index}
											img={`${publicRuntimeConfig.ENV_STATIC_CDN_URL}/images/air/${trInfoArray[1]}.png`}
											title={trInfoArray[0]}
										/>
									);
								})}
								{otherCdCnt > 0 && ` 외 ${otherCdCnt}`}
							</style.Transportation>
						</dd>
					</dl>
				)}
			</style.Summary>
		</>
	);
};

const LocalInfo = (props: Props) => (
	<ErrorBoundary logMsg="Product Info Error">
		<LocalInfoComponent {...props} />
	</ErrorBoundary>
);

export default LocalInfo;
